import React from 'react'
import CopyTooltip from 'components/shared/CopyTooltip'
import { showTooltipConfirmation } from 'state/imperativeApis/tooltipApi'
import { insertToClipboard } from 'utils'
import { isMobile } from 'lib/device'
import cn from 'classnames'

export default function CopyLinkButton({
    children,
    copyContent,
    tip = 'Copy.',
    contextStyles,
    onCopy = undefined,
}) {
    const showConfirmationTooltip = (tipped, confirmationText = 'Copied!', tooltipText) => {
        showTooltipConfirmation(tipped.current, {
            content: confirmationText,
            restoreContent: tooltipText,
            duration: isMobile ? 1000 : 2000,
            closeAfter: isMobile,
        })
    }

    const tooltipText = tip ?? 'Copy'
    const tipped = React.createRef()

    const onClick = ev => {
        ev.preventDefault()
        ev.stopPropagation()

        const copy = copyContent()
        if (copy) {
            insertToClipboard(copy)
            onCopy?.()
            showConfirmationTooltip(tipped, 'Copied!', tooltipText)
        }
    }

    return (
        <div className={cn(contextStyles)} onClick={onClick}>
            <CopyTooltip tip="Copied!" offset={0} ref={tipped}>
                {children}
            </CopyTooltip>
        </div>
    )
}
